import React from 'react';
import { attr } from '../../../utils/easy';
import groupService from '../../../services/group-service';
import userService from '../../../services/user-service';
import DialogComponent, { DialogProps } from '../../widgets/dialog/DialogComponent';

import './ChangePermissionDialog.scss';

export interface FetchedGroup {
  _id?: string;
  parent?: string;
  name?: string;
  description?: string;
}

export interface User {
  _id: string;
  name: string;
}

export interface Props extends DialogProps {
  groupId: string;
}

export interface State {
  group: {
    _id: string;
    supervisors: any[];
  },
  selectedOption: any;
  submiting: boolean;
  subCustomers: User[];
}

export default class ChangePermissionDialog extends DialogComponent<Props, State> {

  state = {
    group: {
      _id: '',
      supervisors: [] as any[]
    },
    subCustomers: [] as User[],
    selectedOption: null,
    submiting: false,
  }

  render() {
    const { subCustomers } = this.state;
    return (
      <React.Fragment>
        <div className="row">
          <div className="col-lg-7 col-md-7 col-9">
            <select className="dialog-input lg-input" onChange={this.onUserSelectChange} defaultValue="-1">
              <option value="-1" disabled>انتخاب کاربر</option>
              {subCustomers.map(sub => (
                <option value={sub._id} key={sub._id}>{sub.name}</option>
              ))}
            </select>
          </div>
          <div className="col-lg-5 col-md-5 col-3 px-0">
            <button className="btn btn-outline-app" onClick={this.onAddClick}>
              <i className="far fa-plus ml-1"></i>
              افزودن
            </button>
          </div>
          <div className="col-12">
            {this.renderSupervisorList()}
          </div>
        </div>
        <div className="d-flex mt-2">
          <button
            onClick={this.onSubmitClick}
            disabled={this.state.submiting}
            className="btn btn-outline-app mx-auto">
            بروزرسانی سطح دسترسی
          </button>
        </div>
      </React.Fragment>
    );
  }

  private renderSupervisorList = () => {
    const count = this.state.group.supervisors.length;
    return (
      <div className={'row' + (count === 0 ? ' empty-list' : '')}>
        <ul className="permission-dialog-list">
          {this.state.group.supervisors.map(item => (
            <li className="col-lg-4 col-12" key={item._id}>
              <div className="item-content">
                <span>{item.name}</span>
                <span className="mr-auto" onClick={this.onRemoveClick} data-id={item._id}>
                  <i className="far fa-times-circle fa-lg"></i>
                </span>
              </div>
            </li>
          ))}
        </ul>
      </div>
    );
  }

  componentDidMount = async () => {
    if (!this.props.groupId) return;
    const group = await groupService.findById(this.props.groupId);
    const users = await userService.list();
    this.setState({ group, subCustomers: users });
  }

  private onUserSelectChange = (event: any) => {
    this.setState({ selectedOption: event.target.value });
  }

  private onAddClick = () => {
    const { subCustomers, group, selectedOption: userId } = this.state;
    if (!userId) return;
    const supervisors = group.supervisors;
    const newUser = subCustomers.find(sub => sub._id === userId);
    const founded = supervisors.find(s => s._id === userId);
    if (!founded) {
      this.setState({
        group: {
          ...group,
          ...{ supervisors: [...supervisors, newUser] }
        }
      })
    }
  }

  private onRemoveClick = (event: any) => {
    const target = event.currentTarget;
    const id = attr(target, 'data-id');
    const group = { ...this.state.group };
    group.supervisors = group.supervisors.filter(s => s._id !== id);
    this.setState({ group })
  }

  private onSubmitClick = async () => {
    this.setState({ submiting: true });
    const group = this.state.group;
    const data = [] as any[];
    group.supervisors.forEach(item => data.push(item._id));
    this.resolve({ groupId: group._id, data });
    this.close();
  }

}
